import { render } from "./LoteFrete.vue?vue&type=template&id=5be13ef6&scoped=true"
import script from "./LoteFrete.vue?vue&type=script&lang=js"
export * from "./LoteFrete.vue?vue&type=script&lang=js"

import "./LoteFrete.vue?vue&type=style&index=0&id=5be13ef6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be13ef6"]])

export default __exports__